/*!
 * CheatsheetView - Vue aide-mémoire & documentation interactive pour IconsView
 */

import CardView from './CardView';

export default class CheatsheetView extends CardView {
    constructor(plugin) {
        super(plugin, 'cheatsheet');
    }

    renderIcon(data, container, subdir, path) {
        const myself = this.plugin;
        if (data.type === 'root') return true;

        myself.viewItemThumbsMode = false;
        const currentType = this.getTypes(data);
        const currentClassAll = this.buildItemClasses(data, currentType, (data.class || data.cls || ''));

        const category = (data.data && data.data.category) || data.category || '';
        const syntax = (data.data && data.data.syntax) || data.syntax || '';
        const description = (data.data && data.data.description) || data.description || '';
        const status = (data.data && data.data.status) || data.status || '';
        const tags = (data.data && data.data.tags) || data.tags || [];

        let badgeCatHtml = '';
        if (category) {
            badgeCatHtml = '<span class="iv__cheatsheet__badge iv__cheatsheet__badge--cat">' + category + '</span>';
        }

        let badgeStatusHtml = '';
        if (status) {
            const statusClass = (status === 'stable' || status === 'v5' || status === 'valid') ? 'badge--success' : (status === 'new' ? 'badge--info' : 'badge--warning');
            badgeStatusHtml = '<span class="badge badge--xs ' + statusClass + '">' + status + '</span>';
        }

        let syntaxHtml = '';
        if (syntax) {
            const escapedSyntax = $('<div>').text(syntax).html();
            syntaxHtml = '<div class="iv__cheatsheet__code-wrap">'
                + '<code class="iv__cheatsheet__code">' + escapedSyntax + '</code>'
                + '<button type="button" class="iv__cheatsheet__copy btn btn--xs btn--ghost" title="Copier la syntaxe">'
                + '<i class="fa-solid fa-copy"></i>'
                + '</button>'
                + '</div>';
        }

        let tagsHtml = '';
        if (Array.isArray(tags) && tags.length) {
            tagsHtml = '<div class="iv__cheatsheet__tags">' + tags.map(t => '<span class="iv__cheatsheet__tag">' + t + '</span>').join('') + '</div>';
        }

        const iconHtml = data.icon ? myself.renderIconImage(24, data.icon, data, 'img') : '<i class="fa-solid fa-code"></i>';

        const code = '<div class="' + currentClassAll + ' iv__item--cheatsheet">'
            + '<div class="iv__item__frame iv__cheatsheet__card">'
                + '<div class="iv__cheatsheet__header">'
                    + '<div class="iv__cheatsheet__title-group">'
                        + '<span class="iv__cheatsheet__icon">' + iconHtml + '</span>'
                        + '<strong class="iv__cheatsheet__name">' + (data.label || '') + '</strong>'
                    + '</div>'
                    + '<div class="iv__cheatsheet__badges">'
                        + badgeCatHtml
                        + badgeStatusHtml
                    + '</div>'
                + '</div>'
                + (description ? '<div class="iv__cheatsheet__desc">' + description + '</div>' : '')
                + syntaxHtml
                + tagsHtml
            + '</div>'
        + '</div>';

        const currentIcon = $(code);
        container.append(currentIcon);
        this.attachItemEvents(currentIcon, currentIcon.find('.iv__cheatsheet__card'), data, currentType, path);
        this.renderBadge(data, currentIcon);

        // Bind copy button
        currentIcon.find('.iv__cheatsheet__copy').on('click', function(e) {
            e.stopPropagation();
            e.preventDefault();
            const textToCopy = syntax;
            if (navigator.clipboard) {
                navigator.clipboard.writeText(textToCopy);
            } else {
                const $temp = $('<textarea>').val(textToCopy).appendTo('body').select();
                document.execCommand('copy');
                $temp.remove();
            }
            const $btn = $(this);
            $btn.html('<i class="fa-solid fa-check" style="color:#22c55e;"></i>');
            setTimeout(() => {
                $btn.html('<i class="fa-solid fa-copy"></i>');
            }, 1500);
        });

        return currentIcon;
    }

    getZoomLimits() {
        return { enabled: true, min: 24, max: 64 };
    }
}
